function valueExistsInArray(array, value) {
  for (const item of array) {
    if (item == value) {
      return true;
    }
  }
  return false;
}
function ApiCellRenderer(params) {
  try {
    const celldata = params.colDef?.options;
    const cellvalue = params.value ? params.value : "";
    if (celldata && cellvalue) {
      if (cellvalue && Array.isArray(cellvalue)) {
        return celldata
          .filter((item) => valueExistsInArray(cellvalue, item.id))
          ?.map((item, index, data) => {
            if (index + 1 === data.length) {
              return [<span>{item.value}</span>];
            } else {
              return [<span>{item.value}</span>, ","];
            }
          });
      } else {
        const datafil = celldata.find((item) => item.id == params.value)?.value;
        return datafil;
      }
    } else {
      return params.value ? params.value : "";
    }
  } catch (error) {
    console.log(error.message);
  }
}

export default ApiCellRenderer;
